import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wvw4kcax73: FaireBrandEntity = {
  token: "b_wvw4kcax73",
  type: "brand",
  name: "Fila Manila Filipino American Kitchen",
  avatarUrl:
    "https://cdn.faire.com/fastly/558b76d0e2e3b4c02f551dad43717490f60a10fe667bcd854341ecfac0674c4b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fbeca3d32081b92727f8db769cd56397d4548aa3a3ede7a8a08b20a4c06697ad.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/558b76d0e2e3b4c02f551dad43717490f60a10fe667bcd854341ecfac0674c4b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fbeca3d32081b92727f8db769cd56397d4548aa3a3ede7a8a08b20a4c06697ad.jpeg",
  location: "Washington, DC, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Launched in 2020, Fila Manila offers an award-winning line of authentic Filipino sauces, spreads, and condiments to – finally – add representation to the 2nd largest Asian American community. The company’s products are inspired by founder Jake Deleon’s favorite dishes growing up as a 1st generation Filipino American immigrant.\n\nFila Manila is the brainchild of first-generation Filipino-American immigrant and entrepreneur Jake Deleon. Jake’s journey as a food entrepreneur started as a child helping his family make and sell Filipino delicacies to family and friends to earn extra money for their household. \n\nDuring the COVID-19 quarantine in 2020, Jake began researching the Filipino diaspora in the U.S.  He found that although Filipinos are the second-largest Asian ethnic group in the country, and Filipino food is the fastest-growing Asian cuisine in the consumer packaged goods market, Filipino food was missing from mass retail grocery store shelves.\n\nArmed with a $1,200 stimulus check, a few beloved family recipes, immigrant grit, and years of expertise in the food business, Jake went to work in the test kitchen. Within a few months, Fila Manila became the best-selling Filipino sauce brand in the U.S.!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:58.798Z",
    importedBy: "entity-db-cli",
  },
};
